import styled from 'styled-components'
import { AlignType, MarginType } from 'common/types/styleTypes'
import {
  marginCss,
  mobileMarginCss,
  mobileTextCss,
  textCss,
} from 'common/utils/styleUtilsNew'

type BlogPostAnnounceDateUiProps = {
  fontSize: number
  color: string
  fontFamily?: string
  fontWeight?: string
  fontStyle?: string
  textAlign: AlignType
  mobileColor?: string
  mobileFontSize?: number
  mobileFontFamily?: string
  mobileFontWeight?: string
  mobileFontStyle?: string
  mobileTextAlign?: AlignType
  margin: MarginType
  mobileMargin: Partial<MarginType>
}
const BlogPostAnnounceDateUi = styled.div<BlogPostAnnounceDateUiProps>`
  ${textCss};
  ${marginCss}
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`

export default BlogPostAnnounceDateUi
